// The orch backend may serialize `estimated_scan_time` either as an
// "HH:MM:SS" string (list endpoint) or as a duration object
// `{ hours, minutes, seconds }` (detail endpoint). The FE contract is a
// string, and the value is rendered directly as a React child — an object
// there throws "Objects are not valid as a React child". Normalize to a
// string at the API boundary so every consumer is safe.
export const formatEstimatedScanTime = (value: unknown): string => {
    if (value == null) return ''
    if (typeof value === 'string') return value
    if (
        typeof value === 'object' &&
        ('hours' in value || 'minutes' in value || 'seconds' in value)
    ) {
        const v = value as { hours?: number; minutes?: number; seconds?: number }
        const pad = (n?: number) => String(n ?? 0).padStart(2, '0')
        return `${pad(v.hours)}:${pad(v.minutes)}:${pad(v.seconds)}`
    }
    return String(value)
}
